import merge from 'lodash/merge'

const initialState = {
  boxTranscriptProducts: {},
  brandings: {},
  clips: {},
  countries: {},
  emailDomains: {},
  highlights: {},
  metaTags: {},
  projects: {},
  reports: {},
  responses: {},
  roles: {},
  searches: {},
  tags: {},
  users: {},
  workspaces: {}
}

export default function entities(state = initialState, action) {
  if (action.response && action.response.entities) {
    return merge({}, state, action.response.entities)
  } else if (action.entities) {
    return merge({}, state, action.entities)
  }

  return state
}



// WEBPACK FOOTER //
// ../src/reducers/entities.js